// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kTf8","title":"Info_title__3koFq","selects":"Info_selects__3khs6","requiredAsterisk":"Info_requiredAsterisk__28Tx-"};